import { render, staticRenderFns } from "./UnconfinedPackageTest.vue?vue&type=template&id=39661ed9&"
import script from "./UnconfinedPackageTest.vue?vue&type=script&lang=js&"
export * from "./UnconfinedPackageTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports